(function() {
  if (window._youtubevideoLoaded) return;
  window._youtubevideoLoaded = true;

function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/**
 * Youtube video player component
 *
 * Notes: mute and fullscreen functionality is hardcoded and will only work within the video-banner.liquid section
 */

class YoutubeVideo extends HTMLElement {
  
  
  
  
  __init() {this.enableMuteButton = false;}
  
  __init2() {this.enableFullscreenButton = false;}
  

  // Icons used for mute/fullscreen buttons
  __init3() {this.mutedIcon =
    '<svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 9L22 15M22 9L16 15M13 3L7 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H7L13 21V3Z" stroke="#ffffff" stroke-width="1.44" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';}
  __init4() {this.unMutedIcon =
    '<svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 9C16.5 9.5 17 10.5 17 12C17 13.5 16.5 14.5 16 15M19 6C20.5 7.5 21 10 21 12C21 14 20.5 16.5 19 18M13 3L7 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H7L13 21V3Z" stroke="#ffffff" stroke-width="1.44" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';}
  __init5() {this.fullscreenIcon =
    '<svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.00002 3.99997H4.00004L4 8.99999M20 8.99999V4L15 3.99997M15 20H20L20 15M4 15L4 20L9.00002 20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';}

  constructor() {
    super();YoutubeVideo.prototype.__init.call(this);YoutubeVideo.prototype.__init2.call(this);YoutubeVideo.prototype.__init3.call(this);YoutubeVideo.prototype.__init4.call(this);YoutubeVideo.prototype.__init5.call(this);
    if (!this.dataset.videoId) {
      return;
    }

    this.shadowElement = this.attachShadow({ mode: 'open' });
    this.iFrameDiv = document.createElement('div');
    this.iFrameDiv.setAttribute('id', 'player');
    this.iFrameDiv.style.minHeight = '200px';
    this.shadowElement.appendChild(this.iFrameDiv);

    // Gather attribute data
    this.videoId = this.dataset.videoId;
    this.enableFullscreenButton = JSON.parse(this.dataset.enableFullscreen);
    this.enableMuteButton = JSON.parse(this.dataset.enableMute);
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);

    if (this.enableFullscreenButton) {
      this.enableFullscreen();
    }

    this.deferVideoPlayer();
  }

  /** Download the IFrame Player API code asynchronously. */
  loadIFrameAPI() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];

    _optionalChain([firstScriptTag, 'optionalAccess', _ => _.parentNode, 'optionalAccess', _2 => _2.insertBefore, 'call', _3 => _3(tag, firstScriptTag)]);
  }

  /** Called by the youtube API. Creates an <iframe> (and YouTube player) after the API code downloads. */
  onYouTubeIframeAPIReady() {
    this.player = new YT.Player(this.iFrameDiv, {
      videoId: this.videoId,
      host: 'https://www.youtube-nocookie.com',
      events: {
        onReady: this.onPlayerReady.bind(this),
      },
      playerVars: {
        playsinline: 1,
        autoplay: 1,
        loop: 1,
        autohide: 1,
        showinfo: 0,
        mute: 1,
        controls: 0,
        modestbranding: 1,
        playlist: this.videoId,
        origin: window.location.host,
      },
    });

    const playerIframe = _optionalChain([this, 'access', _4 => _4.shadowRoot, 'optionalAccess', _5 => _5.querySelector, 'call', _6 => _6('iframe')]);
    playerIframe.style.position = 'absolute';
    playerIframe.style.height = '100%';
    playerIframe.style.width = '450%';
    playerIframe.style.marginLeft = '-175%';
    this.closest('.video-section').style.overflow = 'hidden';
  }

  /** The youtube API will call this function when the video player is ready. */
  onPlayerReady(event) {
    event.target.playVideo();
    // Enable mute functionality
    if (this.enableMuteButton === true) {
      this.enableMute();
    }
  }

  /** Determine when the youtube video should be loaded based on where it is positioned in the dom */
  deferVideoPlayer() {
    if (this.elementInViewport(this.iFrameDiv)) {
      this.loadIFrameAPI();
    } else if (!window.IntersectionObserver) {
      this.loadIFrameAPI();
    } else {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadIFrameAPI();
              observer.unobserve(entry.target);
              this.closest('.video-section').style.overflow = 'hidden';
            }
          });
        },
        {
          rootMargin: '10% 0px 100% 0px',
        }
      );
      observer.observe(this.iFrameDiv);
    }
  }

  /** Check if element is above the fold */
  elementInViewport(element) {
    const bounding = element.getBoundingClientRect();

    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  /**
   * create mute button and hook into youtube iframe api to mute and unmute video
   */
  enableMute() {
    this.muteButton = document.createElement('button');
    this.muteButton.classList.add('button');
    this.muteButton.classList.add('button--mute');
    this.muteButton.innerHTML = this.mutedIcon;
    this.muteButton.id = 'mute';

    _optionalChain([this, 'access', _7 => _7.closest, 'call', _8 => _8('.video-section'), 'optionalAccess', _9 => _9.appendChild, 'call', _10 => _10(this.muteButton)]);

    _optionalChain([document, 'access', _11 => _11.querySelector, 'call', _12 => _12('#mute'), 'optionalAccess', _13 => _13.addEventListener, 'call', _14 => _14('click', () => {
      if (this.player.isMuted()) {
        this.player.unMute();
        this.muteButton.innerHTML = this.unMutedIcon;
      } else {
        this.player.mute();
        this.muteButton.innerHTML = this.mutedIcon;
      }
    })]);
  }

  /**
   * Create & attach fullscreen button and setup fullscreen events
   */
  enableFullscreen() {
    this.fullscreenButton = document.createElement('button');
    this.fullscreenButton.classList.add('button');
    this.fullscreenButton.classList.add('button--fullscreen');
    this.fullscreenButton.innerHTML = this.fullscreenIcon;
    this.fullscreenButton.id = 'fullscreen';

    _optionalChain([this, 'access', _15 => _15.closest, 'call', _16 => _16('.video-section'), 'optionalAccess', _17 => _17.appendChild, 'call', _18 => _18(this.fullscreenButton)]);

    _optionalChain([document, 'access', _19 => _19.querySelector, 'call', _20 => _20('#fullscreen'), 'optionalAccess', _21 => _21.addEventListener, 'call', _22 => _22('click', () => {
      const iframe = this.player.getIframe();
      iframe.allowFullscreen = true;
      iframe.allow += ' ;fullscreen';

      iframe.requestFullscreen().catch(() => {
        alert('Error attempting to enable fullscreen mode');
      });
    })]);

    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement) {
        this.player.unMute();
      } else {
        this.player.mute();
      }
    });
  }
}

if (!customElements.get('youtube-video')) {
  customElements.define('youtube-video', YoutubeVideo);
}

})();